import { useMemo } from 'react'

import { ProfileEntity } from 'src/types'

export const useProfileRequiredToBeUpdated = () => {
  const Key = 'profile'

  const saveProfileRequiredToBeUpdated = (profile: ProfileEntity) => {
    sessionStorage.setItem(Key, JSON.stringify(profile))
  }

  const loadProfileRequiredToBeUpdated = () => {
    const profile = sessionStorage.getItem(Key)
    return profile ? (JSON.parse(profile) as ProfileEntity) : null
  }

  const clearProfileRequiredToBeUpdated = () => {
    sessionStorage.removeItem(Key)
  }

  return {
    profile: useMemo(loadProfileRequiredToBeUpdated, []),
    saveProfileRequiredToBeUpdated,
    clearProfileRequiredToBeUpdated,
  }
}
